import * as React from "react";

export const Watch = ({initRun=false, next=undefined, compare=(v1, v2)=>v1 === v2, value, onChanged}) => React.createElement(Watch1, {
    initRun, next, compare, onChanged, value,
});

interface P<T> {
    value: T;
    next?: () => any;
    compare: (newValue: T, oldValue: T) => boolean;
    onChanged: (newValue: T, oldValue: T) => void;
}

interface S {
}

class Watch1<T> extends React.Component<P<T>,S> {

    constructor(props, context) {
        super(props, context);

        if (props.initRun) {
            props.onChanged(this.props.value, undefined);
        }
    }

    componentDidUpdate(prevProps: Readonly<P<T>>): void {
        if (!this.props.compare(prevProps.value, this.props.value)) {
            this.props.onChanged(this.props.value, prevProps.value);
        }
    }

    render() {
        const {next} = this.props;

        return next ? next() : null;
    }
}
